import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { RADIO_BUTTONS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { CellWrapper } from '../../../common/cell-wrapper';
import type { TransformedRadioSelectField } from '../../../common/field-types/radio-select/types';
import type { BasicListViewItem, FieldCellProps } from '../../../common/types';
import { RadioSelectEdit } from './edit/async';
import type { Option } from './edit/types';
import { RadioSelectRead } from './read';

export const RadioSelect = ({
	rowData: issue,
	cellData: field,
	column: { width: preferredWidth },
	editMode,
	setEditMode,
}: FieldCellProps<BasicListViewItem, TransformedRadioSelectField>) => {
	const [option, setOption] = useState(field?.value ?? null);

	useEffect(() => {
		setOption(field?.value || null);
	}, [field?.value]);

	const isEditable = useMemo(
		() => issue.fieldConfig?.isEditable || false,
		[issue.fieldConfig?.isEditable],
	);

	const handleChange = useCallback(
		(value: Option | null) => {
			setOption(value);
			setEditMode(false);
		},
		[setEditMode, setOption],
	);

	if (field == null) {
		return null;
	}

	return (
		<CellWrapper isEditable={isEditable} hasPadding={false}>
			{editMode ? (
				<RadioSelectEdit
					issueKey={issue.key}
					fieldKey={field.fieldId}
					fieldName={field.name}
					option={option}
					readContent={<RadioSelectRead>{option?.label ?? ''}</RadioSelectRead>}
					preferredWidth={preferredWidth}
					onChange={handleChange}
				/>
			) : (
				<RadioSelectRead>{option?.label ?? ''}</RadioSelectRead>
			)}
		</CellWrapper>
	);
};

export const radioSelectCellHandler = {
	[RADIO_BUTTONS_CF_TYPE]: RadioSelect,
};
